import {cfg} from "@ok/common/modules/cfg/Cfg";
import {IHash} from "@ok/utils/types/IHash";

const testIdConfig = cfg<{enabled: boolean}>("testId");

export class TSID {
    static attrName = "data-tsid";

    static attr(str?: string) {
        return testIdConfig.get().enabled ? str : undefined;
    }

    static assign(str: string, attrs: IHash<string | number> = {}) {
        if (testIdConfig.get().enabled) {
            return { ...attrs, [TSID.attrName]: str};
        }

        return attrs;
    }
}
